import { Box, Container, Typography } from "@mui/material";
import ClientsCarousel from "./carousel";


export default function Middle({ id, certificates }) {
  if (Number(certificates?.length) === 0) return null;

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 11 },
        background: "#fff",
        borderTop: "1px solid #eef2f7",
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: { xs: 5, md: 7 } }}>
          <Typography
            component="h2"
            sx={{
              color: "#0f172a",
              fontWeight: 800,
              letterSpacing: "-.03em",
              fontSize: { xs: "2rem", md: "2.7rem" },
              mb: 1.5,
            }}
          >
            Nossas certificações
          </Typography>

          <Typography
            sx={{
              color: "#64748b",
              maxWidth: 680,
              mx: "auto",
              lineHeight: 1.7,
              fontSize: "1.05rem",
            }}
          >
            Certificados que reforçam nosso compromisso com a qualidade,
            segurança e confiança dos nossos clientes.
          </Typography>
        </Box>

        <ClientsCarousel id={id} certificates={certificates} />
      </Container>
    </Box>
  );
}
